module.exports = __webpack_public_path__ + "Gotham-Medium.otf?27a90e8757eda1edc9872eebec18ba64";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Gotham-Medium.otf
// module id = 10
// module chunks = 0